import { render } from "./SettingsModal.vue?vue&type=template&id=4900220a&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"

import "./SettingsModal.vue?vue&type=style&index=0&id=4900220a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900220a"]])

export default __exports__